import { useQuery } from 'react-query'
import axios from 'axios'
import { captureException } from '@sentry/nextjs'

export enum MILKvKeys {
  FeatureFlag = 'feature_flag',
  WebinarEntries = 'webinar_entries',
  PendaftaranKomunitas = 'ikm_info_page',
  IKMDocuments = 'ikm_document',
  IKMFilter = 'ikm_community_filter',
  IKMCommunityRecommendation = 'ikm_recommended_community',
  RKMMContributionBanner = 'rkmm_kontribusi_banner',
  LearningSeries = 'learning_series',
  TopicSpeed = 'topic_speed',
  DisabledMateriVideo = 'disabled_materi_video',
  FAQSertifikatMandiri = 'faq_sertifikat_mandiri',
  AksiNyataFormFlowImprovement = 'aksi_nyata_form_flow_improvement',
  JurnalPembelajranFormFlowImprovement = 'jurnal_pembelajaran_form_flow_improvement',
  TopicSurveyBanner = 'topic_survey',
  TopikReferensiTab = 'topik_referensi_tab',
  FeaturedAksiNyata = 'featured_aksi_nyata',
  TopicListUpdateInformation = 'topic_list_update_information',
  KMDisclaimer = 'km_disclaimer',
  PenutupanTopik = 'penutupan_topik',
}

let keyValueUrl = !!process.env.NEXT_PUBLIC_BELAJAR_CDN
  ? process.env.NEXT_PUBLIC_BELAJAR_CDN + '/kv'
  : 'https://mil-kv.guru.belajar.id/kv'

function fetchKeyValue<T>(key: string): Promise<{ data: T }> {
  return typeof key === 'undefined'
    ? Promise.reject(new Error('invalid Key'))
    : axios.get(`${keyValueUrl}/${key}.json`)
}

function fetchKeyValueQuery<T>(key: string): Promise<{ data: T }> {
  return typeof key === 'undefined'
    ? Promise.reject(new Error('invalid Key'))
    : axios.get(
        `${process.env.NEXT_PUBLIC_API_URL}/microlearnings/cms/kv?key=${key}`
      )
}

export const DEFAULT_VALUE_AKSI_NYATA_FORM_IMPROVEMENT = {
  INITIAL_CONFIRM: {
    title: 'Kumpulkan umpan balik',
    subtitle: 'Minta umpan balik dari hasil Aksi Nyata yang telah Anda lakukan',
    items: [
      '<p>Kumpulkan <strong>umpan balik dari sasaran Aksi Nyata Anda.</strong></p>',
      '<p>Umpan balik bisa dikumpulkan dalam bentuk formulir, rekap jawaban, atau tangkapan layar. <br />{{url}}</p>',
      '<p>Masukkan umpan balik ke dalam dokumen Aksi Nyata Anda.</p>',
    ],
    urlTitle: 'Lihat contoh umpan balik',
    urlTarget: process.env.NEXT_PUBLIC_BASE_URL,
  },
  BEFORE_FORM: {
    title: 'Lanjut ke Lembar Aksi Nyata?',
    subtitle: 'Cek ulang kelengkapan Aksi Nyata Anda',
    options: [
      'Aksi Nyata sudah dilakukan',
      'Dokumen Aksi Nyata telah dibuat dalam bentuk PDF',
      'Laporan umpan balik telah disertakan di dalam dokumen Aksi Nyata',
    ],
  },
  FORM: {
    uploadField: {
      title: 'Unggah dokumen Aksi Nyata Anda',
      descriptionPoints: [
        'Pastikan dokumen lengkap',
        'Pastikan terdapat laporan umpan balik',
      ],
    },
  },
  AFTER_FORM: {
    title: 'Apakah anda yakin mengumpulkan Aksi Nyata?',
    subtitle:
      'Pastikan Aksi Nyata memenuhi kriteria di bawah ini untuk mempermudah memperoleh validasi',
    highlightedPoints: [
      'Tidak plagiat karya Aksi Nyata orang lain',
      'Aktifitas Aksi Nyata sesuai dengan panduan',
      'Dokumentasi lengkap',
      'Menyertakan laporan umpan balik di dalam dokumen',
    ],
    buttonTitle: 'Kumpulkan',
  },
}

export function useGetKeyPairValue<T = any>(
  key: string,
  enabled: boolean = true,
  queryConfig = {}
) {
  return useQuery([keyValueUrl, key], () => fetchKeyValue<T>(key), {
    ...queryConfig,
    onError: (error) => captureException(error),
    enabled,
  })
}

export function useGetKeyValueQuery<T = any>(
  key: string,
  enabled: boolean = true,
  queryConfig = {}
) {
  return useQuery([keyValueUrl, key], () => fetchKeyValueQuery<T>(key), {
    ...queryConfig,
    onError: (error) => captureException(error),
    enabled,
  })
}
